<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="10">
                                    <h3>{{title}}</h3>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col  cols="12" md="6">
                                <base-input :label="language_terms['CODE']" v-model="form.code" :disabled="!is_edit || id != '_new'"></base-input>
                            </b-col>
                            <b-col cols="12" md="6">
                                <base-input :label="language_terms['BANK_NAME']" v-model="form.bank_name" :disabled="!is_edit"></base-input>
                            </b-col>
                            <b-col cols="12" md="4">
                                 <base-input :label="language_terms['CURRENCY']">
                                    <el-select v-model="form.currency_code" filterable :disabled="!is_edit">
                                        <el-option v-for="option in currency_options"
                                             :key="option.code"
                                             :label="option.code + ' - ' + option.name"
                                             :value="option.code">
                                         </el-option>
                                    </el-select>
                                </base-input>
                             </b-col>
                             <b-col cols="12" md="4">
                                 <base-input :label="language_terms['ACCOUNT_CODE']">
                                    <el-select v-model="form.account_code" filterable :disabled="!is_edit">
                                        <el-option v-for="option in account_options"
                                             :key="option.code"
                                             :label="option.code + ' - ' + option.name"
                                             :value="option.code">
                                         </el-option>
                                    </el-select>
                                </base-input>
                             </b-col>
                             <b-col cols="12" md="4">
                                 <base-input :label="language_terms['COUNTRY']">
                                    <el-select v-model="form.country_code" filterable :disabled="!is_edit">
                                        <el-option v-for="option in country_options"
                                             :key="option.code"
                                             :label="option.name"
                                             :value="option.code">
                                         </el-option>
                                    </el-select>
                                </base-input>
                             </b-col>
                        </b-row>
                        <b-row>
                  <b-col md="12">
                    <base-input 
                    label="Bank Address"
                    >
                      <textarea
                        :disabled="!is_edit"
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        v-model="form.bank_address">
                      </textarea>
                    </base-input>
                  </b-col>
                </b-row>
                        <b-row class="mt-6">
                            <b-col cols="12" md="3">
                                <b-form-checkbox class="mb-3 ml-4" v-model="form.is_active" value="1" unchecked-value="0" :disabled="!is_edit" switch>
                                    {{language_terms['IS_ACTIVE']}}
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" md="3">
                                <b-form-checkbox class="mb-3 ml-4" v-model="form.is_recon" value="1" unchecked-value="0" :disabled="!is_edit" switch>
                                    {{language_terms['REQUIRED_RECON']}}
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn"  @click="clickOnedit" v-if="!is_edit">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="onClickSave()" v-if="is_edit">
                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancel" v-if="is_edit">
                            <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                        </b-button>
                        <b-button class="transparent-btn" v-if="$route.params.id != '_new'"  @click="deleteData">
                            <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="clickOnBack">
                            <i class="fas fa-arrow-left mr-2 text-success"></i>{{language_terms['BACK']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>

    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import {Table,TableColumn,Select, Option } from "element-ui";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            is_created: state => state.contactCategories.is_created,
            is_updated: state => state.contactCategories.is_updated,
            is_deleted: state => state.contactCategories.is_deleted,
            contact_categories: (state) => state.contactCategories.contact_categories,
            contact_category_filter: (state) => state.contactCategories.filter,
            contact_category_data: (state) => state.contactCategories.data
        })
    },
    components:{
        Loading,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,        
    },
    data(){
        return{
            form:{
            code: null,
            bank_name: null,
            currency_code: 'SGD',
            account_code: null,
            country_code: 'SG',
            bank_address: null,
            is_active: 1,
            is_recon:1,
            },
            loading:false,
            title:"",
            is_edit:false,
            contact_category:{
                code:"",
                name:"",
                is_active:"1",
                is_customer:"0",
                is_vendor:"0",
                is_employee:"0"
            },
            currency_options:[],
            account_options:[],
            country_options:[],
        }
    },
    async mounted()
    {
        this.id = this.$route.params.id

        this.loadDefaultOptions()

        if(this.id == '_new')
        {
            this.title = this.language_terms['NEW_BANK_ACCOUNT']
            this.is_edit = true
        }
        else
        {
            //alert('We are loading for ' + id)
            await this.retrieve(this.id)
        }

    },
    methods:{
        async retrieve(bankaccount_code)
        {
            let payload = {code:bankaccount_code}
            await axios
            .post(apiRoutes["BANKACCOUNTS_RETRIEVE"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.form = response.data.data
                } 
                else 
                {
                    alert('Failed');
                }

            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });
        },
        async loadDefaultOptions()
        {
            // 1 - Load Currencies
            let payload = []
            await axios
            .post(apiRoutes["CURRENCIES_LIST"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.currency_options = response.data.data
                } 
                else 
                {
                    alert('Failed');
                }

            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });

            // 2 - Load Countries
            payload = []
            await axios
            .post(apiRoutes["COUNTRY_LIST"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.country_options = response.data.data
                } 
                else 
                {
                    alert('Failed');
                }

            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });
            
            
            // 3 - Load Account Codes
            payload = []
            await axios
            .post(apiRoutes["GET_ACCOUNTS_FOR_FY"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.account_options = response.data.data
                } 
                else 
                    Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });
        },
        clickOnedit()
        {
            this.is_edit = true
        },
        async deleteData()
        {
            await this.$store.dispatch("contactCategories/delete", this.contact_category);
            if(this.is_deleted)
            {
                await this.search()
                this.$router.push("/settings/bank-accounts")
            }
        },
        async onClickSave()
        {
            this.loading = true
            if(this.$route.params.id == '_new')
            {
                let payload = this.form
                await axios
                .post(apiRoutes["BANKACCOUNTS_CREATE"], payload, authHeader())
                .then((response) => 
                {
                    if (response.data.code == 1) {
                        this.is_edit = 0;
                        this.$router.push("/settings/bank-account/" + encodeURIComponent(this.form.code))
                    } 
                    else 
                    {
                        alert('Failed');
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    }
                });
            }
            else
            {
                let payload = this.form
                await axios
                .post(apiRoutes["BANKACCOUNTS_UPDATE"], payload, authHeader())
                .then((response) => 
                {
                    if (response.data.code == 1) {
                        Vue.notify({group: "notify", type: "success", text: 'Data Updated', max: 5, duration: 5000, speed: 300,});
                        this.is_edit = 0;
                    } 
                    else 
                    {
                        Vue.notify({group: "notify", type: "error", text: 'Update failed', max: 5, duration: 5000, speed: 300,});
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    }
                });
            }

            this.loading = false

        },
        async search()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.contact_category_filter)
            {
                filter = this.contact_category_filter
            }
            await this.$store.dispatch('contactCategories/quickSearch', filter)

            this.loading = false
        },
        clickOnBack()
        {
            this.$router.push("/settings/bank-accounts")
        },
        async cancel()
        {
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/settings/bank-accounts")
            }
            else
            {
                location.reload();
            }    
        }
    }
}

</script>